var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoIcon1Color(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.5 24.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "promo-icon-1-color_svg__Icon_-_Bonus",
    "data-name": "Icon - Bonus",
    transform: "translate(.031 .031)",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "promo-icon-1-color_svg__Ellipse_281",
    "data-name": "Ellipse 281",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(.719 .719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "promo-icon-1-color_svg__Path_5127",
    "data-name": "Path 5127",
    d: "M11.242 4.464L12.9 8.046h3.234A.793.793 0 0116.7 9.43l-2.8 2.762 1.555 3.572a.848.848 0 01-1.206 1.059l-3.759-2.115-3.769 2.116a.847.847 0 01-1.206-1.059l1.555-3.571-2.8-2.762a.791.791 0 01.55-1.386h3.234l1.66-3.582a.862.862 0 011.528 0z",
    transform: "translate(1.75 1.75)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC41IDI0LjUiPgoJPGcgaWQ9Ikljb25fLV9Cb251cyIgZGF0YS1uYW1lPSJJY29uIC0gQm9udXMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDMxIDAuMDMxKSI+CgkJPGNpcmNsZSBpZD0iRWxsaXBzZV8yODEiIGRhdGEtbmFtZT0iRWxsaXBzZSAyODEiIGN4PSIxMS41IiBjeT0iMTEuNSIgcj0iMTEuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC43MTkgMC43MTkpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmIxMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiIC8+CgkJPHBhdGggaWQ9IlBhdGhfNTEyNyIgZGF0YS1uYW1lPSJQYXRoIDUxMjciIGQ9Ik0xMS4yNDIsNC40NjQsMTIuOSw4LjA0NmgzLjIzNEEuNzkzLjc5MywwLDAsMSwxNi43LDkuNDNsLTIuOCwyLjc2MiwxLjU1NSwzLjU3MmEuODQ4Ljg0OCwwLDAsMS0xLjIwNiwxLjA1OWwtMy43NTktMi4xMTVMNi43MjEsMTYuODI0YS44NDcuODQ3LDAsMCwxLTEuMjA2LTEuMDU5bDEuNTU1LTMuNTcxLTIuOC0yLjc2MkEuNzkxLjc5MSwwLDAsMSw0LjgyLDguMDQ2SDguMDU0bDEuNjYtMy41ODJhLjg2Mi44NjIsMCwwLDEsMS41MjgsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuNzUgMS43NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmYjEwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIgLz4KCTwvZz4KPC9zdmc+Cg==";
export { SvgPromoIcon1Color as ReactComponent };